import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import ListGrid from '../../common/components/ListGrid/ListGrid';
import TableWrapper from '../../common/components/TableWrapper/TableWrapper';
import ListActions from '../../common/components/ListActions';
import Title from '../../common/components/Title';
import {OrdersBundle} from "../../utils/ordersBundle";
import SessionsTable from "./SessionsTable";
import {FiltersBundle} from "../../utils/filtersBundle";
import Checkbox from "@mui/material/Checkbox";
import {Input} from "@mui/material";
import {toggleOneMany} from "../../utils/helpers";
import DeleteButton from "../../common/components/DeleteButton/DeleteButton";
import {Permission} from "../../components/SessionInfo";
import {hetch} from "../../utils/fetch.hooked";

function Sessions({ permission }) {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [isFetching, setIsFetching] = useState(false);
    const [refetch, setRefetch] = useState(false);
    const [page, setPage] = useState(query.get('pageNumber') ?? 1);
    const [count, setCount] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [rows, setRows] = useState(null);
    const [sortOrders, setSortOrders] = useState('');
    const [filterFields, setFilterFields] = useState('');
    const [globalSelected, setGlobalSelected] = useState(false);
    const [selectedList, setSelectedList] = useState(new Set());
    const toggleInSet = (value, state) => {
        if (!!state) selectedList.add(value);
        else selectedList.delete(value);
        setSelectedList(new Set([...selectedList]));
    }

    const [isDeleteFetching, setIsDeleteFetching] = useState(false);

    const removeList = () => {
        setIsDeleteFetching(true);
        hetch(`/api/sessions/${[...selectedList].join(',')}`, {
            headers: {'Content-Type': 'application/json'},
            method: 'DELETE',
            body: null
        })
        .then(() => {
            setSelectedList(new Set());
            triggerRefetch()
        })
        .finally(() => setIsDeleteFetching(false));
    }

    const ordersBundle = new OrdersBundle({
            login: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
            ip: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
            duration: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        },
        sortOrders, setSortOrders
    )
    const filterBundle = new FiltersBundle({
        login: useState(''),
        ip: useState(''),
    }, filterFields, setFilterFields)

    const triggerRefetch = () => setRefetch(refetch => !refetch);
    const buildSearchParams = () => {
        let p = {
            pageNumber: page,
            pageSize: pageSize,
        };
        if (sortOrders.length > 0) {
            p.sortFields = sortOrders;
        }
        if (filterFields.length > 0) {
            p.filterFields = filterFields;
        }
        return new URLSearchParams(p).toString();
    }

    useEffect(() => {
        history.push({
            search: `pageNumber=${page}`
        })
    }, [history, page]);

    useEffect(() => {
        const fetchData = () => {
            setIsFetching(true);
            hetch(`/api/sessions?` + buildSearchParams())
                .then(res => res.json())
                .then((sessionsRes) => {
                    setRows(sessionsRes?.content ?? []);
                    setCount(Math.ceil(sessionsRes.total / sessionsRes.pageSize));
                })
                .finally(() => {
                    setIsFetching(false);
                });
        }

        fetchData();
    }, [page, pageSize, sortOrders, filterFields, refetch]);

    const defaultWidth = undefined;
    const [loginWidth, setLoginWidth] = useState(defaultWidth);
    const [ipWidth, setIpWidth] = useState(defaultWidth);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLoginWidth(document.querySelector('#loginHead')?.getBoundingClientRect()?.width - 32 ?? defaultWidth);
            setIpWidth(document.querySelector('#ipHead')?.getBoundingClientRect()?.width - 32 ?? defaultWidth);
        }, 300);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const handleChange = (event, value) => {
        setPage(value);
    };
    const limitLength = (str, maxLength) => str.length > maxLength ? str.substring(0, maxLength) : str;
    return (
        <>
            <ListGrid
                header={(
                    <>
                    <Title
                        title="Журнал сеансов"
                        actions={(
                            <ListActions
                                refreshTitle="Обновить журнал сеансов"
                                permission={permission}
                                isRefreshing={isFetching}
                                onRefreshClick={() => triggerRefetch(refetch => !refetch)}
                                pageSizes={[25, 50, 100]}
                                pageSize={pageSize}
                                onPageSizeChange={(size) => { setPage(1); setPageSize(size) } }
                            />
                        )}
                    />
                    </>
                )}
                body={(
                    <>

                        <TableWrapper
                            rows={rows}
                            count={count}
                            page={page}
                            emptyAlertText="Журнал сеансов пуст"
                            isFetching={isFetching}
                            onChange={handleChange}
                            filter={
                                <div style={{padding: '0 0 8px'}}>
                                    {permission === Permission.WRITE
                                        ? <span style={{padding: '0 16px'}}>
                                            <Checkbox checked={globalSelected}
                                                      onChange={(e) => setGlobalSelected(e.target.checked)}></Checkbox>
                                          </span>
                                        : null
                                    }
                                    <span style={{padding: '0 16px'}}>
                                        <Input placeholder={"Логин"}
                                               style={{width: loginWidth+'px'}}
                                               onChange={(e) => filterBundle.setFilter('login', limitLength(e.target.value, 100))}
                                               value={filterBundle.getFilter('login').value}/>
                                    </span>
                                    <span style={{padding: '0 16px'}}>
                                        <Input placeholder={"IP адрес"}
                                               style={{width: ipWidth+'px'}}
                                               onChange={(e) => filterBundle.setFilter('ip', limitLength(e.target.value, 39))}
                                               value={filterBundle.getFilter('ip').value}/>
                                    </span>
                                    {selectedList.size > 0 && permission === Permission.WRITE
                                        ? <DeleteButton
                                            title="Завершить сеанс"
                                            header="Подтверждение завершения"
                                            message={"Вы действительно хотите завершить " + selectedList.size + " " + toggleOneMany(selectedList.size, 'сеанс', 'сеанса', 'сеансов') + "?"}
                                            yesText="Завершить"
                                            variant="contained"
                                            padding="6px 16px"
                                            text={"Завершить " + selectedList.size + " " + toggleOneMany(selectedList.size, 'сеанс', 'сеанса', 'сеансов')}
                                            isFetching={isDeleteFetching}
                                            onConfirm={removeList}
                                        />
                                        : null
                                    }
                                </div>
                            }
                        >
                            <>

                                <SessionsTable globalSelected={globalSelected} filterBundle={filterBundle}
                                               ordersBundle={ordersBundle} permission={permission}
                                               toggleInSet={toggleInSet}
                                               rows={rows} triggerRefetch={triggerRefetch}/>
                            </>
                        </TableWrapper>
                    </>
                )}
            />
        </>
    );
}

export default Sessions;
